define('ext',['cq'], function (cq) {
    return cq.Ext;
});
